function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.31 90.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.39,5.14h-69A4.54,4.54,0,0,0,7,9.73V40.78a1.74,1.74,0,1,0,3.48,0v-31a1,1,0,0,1,1-1h69a1,1,0,0,1,1,1v69.5a1,1,0,0,1-1,1h-69a1,1,0,0,1-1-1V54.94A3.37,3.37,0,0,0,8.7,48.75a3.32,3.32,0,0,0-3.27,3.36A3.36,3.36,0,0,0,7,54.94v24.3a4.54,4.54,0,0,0,4.48,4.59h69a4.54,4.54,0,0,0,4.48-4.59V9.73A4.54,4.54,0,0,0,80.39,5.14Z",
    style: {
      fill: "#006098"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,62.88l7.33-33.63h3.92l7.33,33.63h-4.7l-1.38-7.23H33.1l-1.38,7.23H27ZM38.62,51.12l-2.3-12.19h-.09l-2.3,12.19h4.69Z",
    style: {
      fill: "#0075c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.05,43V35h3.69V43h7.81v3.78H57.74v8.06H54.05V46.82H46.24V43Z",
    style: {
      fill: "#0075c9"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmIcon);
export default __webpack_public_path__ + "static/media/amIcon.6477ad89.svg";
export { ForwardRef as ReactComponent };